export default {
	close: 'Chiudi',
	dataIterator: {
		noResultsText: 'Nessun risultato trovato',
		loadingText: 'Caricamento in corso...',
	},
	dataTable: {
		itemsPerPageText: 'Righe per pagina:',
		ariaLabel: {
			sortDescending: ": Ordinati in ordine decrescente. Attiva per rimuovere l'ordinamento.",
			sortAscending: ': Ordinati in ordine crescente. Attiva per ordinare in ordine decrescente.',
			sortNone: ': Non ordinato. Attiva per ordinare in ordine crescente.',
		},
		sortBy: 'Ordina per',
	},
	dataFooter: {
		itemsPerPageText: 'Elementi per pagina:',
		itemsPerPageAll: 'Tutti',
		nextPage: 'Pagina seguente',
		prevPage: 'Pagina precedente',
		firstPage: 'Pagina prima',
		lastPage: 'Pagina ultima',
		pageText: '{0}-{1} di {2}',
	},
	datePicker: {
		itemsSelected: '{0} selezionati',
	},
	noDataText: 'Nessun elemento disponibile',
	carousel: {
		prev: 'Vista precedente',
		next: 'Prossima vista',
		ariaLabel: {
			delimiter: 'Carousel slide {0} of {1}',
		},
	},
	calendar: {
		moreEvents: '{0} di più',
	},
	fileInput: {
		counter: '{0} files',
		counterSize: '{0} files ({1} in totale)',
	},
	timePicker: {
		am: 'AM',
		pm: 'PM',
	},
	front: {
		tags: 'Tags',
		stats: 'Statistiche',
		stayconnected: 'Resta connesso',
		communications: 'Comunicazioni',
		users: 'Utenti',
		permissions: 'Permessi',
		permissionsByRole: 'Permessi per Ruolo',
		permissionsByProfile: 'Permessi per Profilo',
		setting: 'Impostazioni',
		attributes: 'Attributi',
		variants: 'Varianti',
		suppliers: 'Fornitori',
		snapshot: 'Snapshot',
		inventory: 'Inventario',
		bought: 'Acquisti',
		returns: 'Resi',
		newsletters: 'Newsletters',
		cartadandoned: 'Carrello abbandonato',
		affiliate: {
			affiliate: 'Affiliazione',
			marketing: 'Marketing',
			partner: 'Partner',
		},
		ecommerce: {
			home: 'Sito Ecommerce',
			pages: 'Pagine Statiche',
			layout: 'Layout',
			shipmentmethod: 'Metodi di spedizione',
			shipmentcost: 'Costi di spedizione',
			categoriesevidence: 'Categorie in evidenza',
			themeSettings: 'Impostazioni Tema',
			emailtemplate: 'Configurazione email',
			authentication: 'Autenticazione',
			coupon: 'Coupon / Automazione',
			offers: 'Offerte',
			cartend: 'Fine carrello',
			blog: 'Piano editoriale',
			assistant: 'Assistente virtuale',
			giftcard: 'Carta regalo',
			loyalty: 'Scheda a punti',
			loyaltyRequests: 'Richieste premi',
		},
		warehouse: {
			home: 'Incoming/Outcoming',
			detail: 'Dettaglio',
			incoming: 'Carico',
			outcoming: 'Scarico',
			cashout: 'Cassa',
			inventory: 'Inventario',
			ddt: 'Ddt',
		},
		//items:'Prodotti',
		subsetting: {
			framework: 'CMS e-commerce',
			store: 'Store',
			marketplace: 'Marketplace',
			language: 'Lingue',
			finance: 'Finanza',
			payments: 'Metodi di pagamento',
			api_payments: 'Gateway Pagamenti',
			carriers: 'Corrieri',
			packagings: 'Packaging',
			languages: 'Lingue',
			newsletters: 'Newsletters',
			currencies: 'Valute',
			vat: 'Aliquota',
			unit: 'Unità di misura',
			thumbnail: 'Immagini',
			percentage: '% Prezzi',
			listing: 'Listini',
			stats: 'Statistiche / Grafici',
			seo: 'Seo / Marketing / Traduzioni',
			couriers: 'Corrieri',
			statusOrder: 'Status Ordini',
			orders: 'Ordini',
			orderTags: 'Tag ordini',
			smtpEmail: 'Smtp / Imap / Newsletters',
			communication: 'Comunicazioni',
		},
		values: 'Valori',
		items: {
			items: 'Prodotti',
			riordino: 'Riordino',
			list: 'Lista prodotti',
			edit: 'Modifica prodotto',
			duplicate: 'Duplica prodotto',
			delete: 'Elimina prodotto',
			create: 'Nuovo prodotto',
			condition: 'Condizione',
			additionalTab: 'Tab aggiuntivi',
			additionalOptions: 'Attributi aggiuntivi',
			handlerAdditionalOptions:
				'Definisci gli attributi aggiuntivi disponibili nella scheda prodotto: il valore di ognuno si compila poi sul singolo prodotto. Il campo "Opzioni" serve solo per il tipo "Elenco".',
			slug: 'Slug',
			sku: 'Generatore SKU',
			barcode: 'Generatore Barcode',
			etichetta: 'Etichetta',

			giacenze: 'Giacenze',

			gestionegiacenze: "Le giacenze dei prodotti verrano scalate con quale status dell'ordine?",
			riarrange: 'Riordino',
			handlerriarrange: 'Attivando questa opzione si potranno gestire gli alert per riordino per singola variante',
			restricted: 'Vendita per utenti maggiorenni con autenticazione  ',
			handlerrestricted:
				'Attivando questa opzione nella gestione dei prodotti ci sarà questa opzione nei prodotti. Attivandola i prodotti selezionati saranno vendibili solo per clienti maggiorenni ed autenticati',
		},
		customers: {
			items: 'Clienti',
			list: 'Lista clienti',
			edit: 'Modifica cliente',
			duplicate: 'Duplica cliente',
			delete: 'Elimina cliente',
			create: 'Nuovo cliente',
			condition: 'Condizione',
		},
		agents: {
			items: 'Agenti',
			list: 'Agenti',
			edit: 'Modifica agente',
			duplicate: 'Duplica agente',
			delete: 'Elimina agente',
			create: 'Nuovo agente',
		},
		notifiche: {
			all: 'Visualizza tutte le notifihe',
			notifiche: 'Notifiche',
		},
		employee: {
			items: 'Dipendenti',
		},
		messages: {
			all: 'Visualizza tutte le comunicazioni',
			items: 'Comunicazioni',
			list: 'Lista Comunicazioni',
			create: 'Invia comunicazioni',
		},

		documents: {
			all: 'Visualizza tutti i documenti',
			items: 'Documenti',
			list: 'Lista Documenti',
			create: 'Invia Documenti',
		},

		orders: {
			create: 'Nuovo ordine',
		},
		language: {
			it: 'Italiano',
			en: 'Inglese',
			de: 'Tedesco',
			fr: 'Francese',
			es: 'Spagnolo',
		},
		// menu
		preOrder: 'Pre vendita',
		supplier: 'Fornitori',
		categories: 'Categorie',
		brands: 'Marche',
		filters: 'Filtri',
		Order: 'Ordinamento',
		Shipping: 'Spedizione',
		postOrder: 'Post vendita',
		listOrder: 'Ordini',
		listShipping: 'Spedizioni',
		monitorShipping: 'Spedizioni Monitoraggio',
		listOrderAgents: 'Ordini Agenti',
		listOrderSuppliers: 'Ordini a Fornitore',
		importMagento: 'Importa da Magento',
		importEbay: 'Importa da Ebay',
		importAmazon: 'Importa da Amazon',
		listCustomer: 'Clienti',
		packingList: 'Packing List',
	},
	errors: {
		422: 'Unprocessable Entity', //Il server comprende il tipo di contenuto dell'entità richiesta e la sintassi della richiesta è corretta, ma non è in grado di processare le istruzioni contenute nella richiesta.
		401: 'Non autorizzato',
		402: 'Payment Required',
		400: 'Bad Request', //'Richiesta non può essere soddisfatta.',
		403: 'Richiesta non siddisfatta dal server.',
		405: 'Method Not Allowed', //'Metodo non permesso',
		408: 'Request Timeout',
		429: 'Too many requests',
		413: 'Request Entity Too Large',
		1000: 'Inserisci una mail valida name@server.com',
		1001: 'Email non presente!!!',
		1002: 'Password > 5 Caratteri',
		1003: 'Password errata',
		1004: 'Non autorizzato,Email errata !!!',
		1005: 'Utente non attivo !!!',
		1006: 'Email già presente',
		1007: 'Errore inserimento',
		1008: 'Selezionare lingua di default',
		1009: "Azienda non attiva, contatta l'assistenza",
		1010: 'Codice di verifica non valido',
		1011: 'Troppi tentativi, rifai il login',
		1012: 'Verifica scaduta, rifai il login',
		1013: 'Attendi un minuto prima di richiedere un nuovo codice',
		1014: 'Il link non è valido o è scaduto: richiedine uno nuovo',
		1015: "Troppe richieste, riprova tra un'ora",
		1016: 'La password deve avere almeno 8 caratteri',
		// categorie
		2001: 'Status richiesto',
		2002: 'Operazione fallita',
	},
	messages: {
		2000: 'Operazione effettuata con successo', //Il server comprende il tipo di contenuto dell'entità richiesta e la sintassi della richiesta è corretta, ma non è in grado di processare le istruzioni contenute nella richiesta.
		2001: 'Utente Loggato',
		2002: 'Token eliminato',
	},
};
